import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-95543350"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "steps" }
const _hoisted_2 = { class: "steps__title" }
const _hoisted_3 = { class: "steps__content" }
const _hoisted_4 = { class: "steps__name" }
const _hoisted_5 = { class: "steps__info" }
const _hoisted_6 = { class: "steps__count" }

import { useI18n } from 'vue-i18n';

interface IStep {
  title: string;
  info: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Steps',
  setup(__props) {

const { t } = useI18n();

const steps: IStep[] = [
  {
    title: t('page_home_steps_section_step_1_title'),
    info: t('page_home_steps_section_step_1_info'),
  },
  {
    title: t('page_home_steps_section_step_2_title'),
    info: t('page_home_steps_section_step_2_info'),
  },
  {
    title: t('page_home_steps_section_step_3_title'),
    info: t('page_home_steps_section_step_3_info'),
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_unref(t)('page_home_steps_section_title')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(steps, (step, i) => {
        return _createElementVNode("div", {
          class: "steps__item",
          key: i
        }, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(step.title), 1),
          _createElementVNode("p", _hoisted_5, _toDisplayString(step.info), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(`0${i + 1}`), 1)
        ])
      }), 64))
    ])
  ]))
}
}

})